import { Breakpoints } from './settings';

( function StickyScroll( $ ) {

    const $scroll_elements = $( document.querySelectorAll( '[data-sticky-container]' ) );

    // Only run if we have to.
    if( ! $scroll_elements.length ) {
        return;
    }

    runStickyScrolls();
    $(window).on( 'resize', runStickyScrolls );


    /**
     * Run the sticky scrolls.
     */
    function runStickyScrolls() {

        // Only run for large screens
        if( ! Breakpoints.lgUp() ) {
            return;
        }

        $( window ).on( 'scroll', () => {

            const scroll_top = window.scrollY;

            $scroll_elements.each( function() {

                const $this = $(this);
                const position = $this.offset().top;
                const offset_attr = $this.attr( 'data-offset' );
                const offset = ( offset_attr ? parseInt( offset_attr ) : 0 );


                // Scrolled past
                if(
                    position <= scroll_top + offset &&
                    ! $this.hasClass( 'is-stuck' )
                ) {

                    $this.addClass( 'is-stuck' );
                    $this.find( '[data-sticky-content]' ).css( 'top', offset );
                }
                else if( position > scroll_top + offset ) {

                    $this.removeClass( 'is-stuck' );

                }
            } );

        } );
    }


})( jQuery );


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/sticky-scroll.js